require('./contractEasyLoanStep2.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');

// @core
const { FormattedText } = require('core/i18n').i18n;
//@components
const ContractLoanAccounts = require('../../contractLoanAccounts/contractLoanAccounts');
const ContractLoanDaySelector = require('../../contractLoanDaySelector/contractLoanDaySelector');
//@commons
const { OKMessage } = require('commonsComponents/OKMessage');
// @constants
const { BLOCKED_ACCOUNTS_CONTRACT } = require('constants/operationCodesAccounts');
const {
    NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES,
    EVIDENCE_EASY_LOAN
} = require('constants/flagBasedFeatures');
// @utilities
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class ContractEasyLoanStepTwo extends React.Component {
    constructor(props) {
        super(props);
        this.handlePaymentDayChange = this.handlePaymentDayChange.bind(this);
    }

     componentDidUpdate(){
        const { immContractEasyLoan, immFlagBasedFeatures, setInitApiFlag, toggleINEAgreeCheckbox , onAgreeReset, officePrintReset, resetMailSent} = this.props
         if(immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && immFlagBasedFeatures.get(EVIDENCE_EASY_LOAN)
            || immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && !immFlagBasedFeatures.get(EVIDENCE_EASY_LOAN)){
            
            if((immContractEasyLoan.get('selectedAccount') !== immContractEasyLoan.get('firstSelectedAccount')) || 
                (immContractEasyLoan.get('paymentDaySelected') !== immContractEasyLoan.get('firstPaymentDaySelected')))
                { 
                    setInitApiFlag(true,true, false, false)
                     if (immContractEasyLoan.get('agreeIneCheckbox')){
                         onAgreeReset();
                     }
                     if(isPrintOfficeMode() && immContractEasyLoan.get('officePrintStepThree')){
                        officePrintReset();
                    }
                    __CONTACT_CENTER__ && !isPrintOfficeMode() && resetMailSent(false)
                 }
                 else {
                    setInitApiFlag(false,false,true, false)
                         if(!immContractEasyLoan.get('agreeIneCheckbox')){
                            toggleINEAgreeCheckbox()
                         }
                         if(isPrintOfficeMode() && !immContractEasyLoan.get('officePrintStepThree')){
                            officePrintReset(true);
                        }
                        __CONTACT_CENTER__ && !isPrintOfficeMode() && resetMailSent(true)
                    }
                }
    
     }

    buildRadioButtonSection() {
        const paymentDaySelected = this.props.immContractEasyLoan.get('paymentDaySelected');

        return (
            <ContractLoanDaySelector
                firstRadioButtonLabel="contractEasyLoanStepTwo-firstRadioButtonLabel"
                onPaymentDayChange={this.handlePaymentDayChange}
                paymentDaySelected={paymentDaySelected}
                secondRadioButtonLabel="contractEasyLoanStepTwo-secondRadioButtonLabel"
            />
        );
    }

    handlePaymentDayChange(value) {
        this.props.setPaymentDay({ paymentDay: value });
        this.props.getInstallment();
    }

    buildAccounts() {
        const {
            getBlockedAccounts,
            immAccounts, 
            immContractEasyLoan,
            immFlagBasedFeatures,
            setSelectedAccount 
        } = this.props;
        const selectedAccount = immContractEasyLoan.get('selectedAccount');
        const errorSelectedAccount = immContractEasyLoan.get('errorSelectedAccount')
        const disclaimer = {
            warning: 'contractEasyLoan-contractEasyLoan_blockedAccountsWarning',
            important: 'contractEasyLoan-contractEasyLoan_blockedAccountsImportant'
        };

        return (
            <ContractLoanAccounts
                blockedAccountsContract={BLOCKED_ACCOUNTS_CONTRACT}
                disclaimer={disclaimer}
                getBlockedAccounts={getBlockedAccounts}
                immAccounts={immAccounts}
                immFlagBasedFeatures={immFlagBasedFeatures}
                setSelectedAccount={setSelectedAccount}
                selectedAccount={selectedAccount}
                errorSelectedAccount={errorSelectedAccount}
            />
        );
    }

    render() {
        const radioButtonSection = this.buildRadioButtonSection();
        const accounts = this.buildAccounts();

        return (
            <section className="contract-easy-loan-step-two">
                <div className="contract-easy-loan-step-two__subtitle">
                    <FormattedText value="contractEasyLoanStepTwo-associateAccount" />
                </div>
                {accounts}
                {radioButtonSection}
                <div className="contract-easy-loan-step-two__monthly-quote-message">
                    <OKMessage type="informative">
                        <FormattedText value="contractEasyLoanStepTwo-monthlyQuoteMessage" />
                    </OKMessage>
                </div>
            </section>
        );
    }
}

ContractEasyLoanStepTwo.propTypes = {
    beforeStep: PropTypes.number.isRequired,
    errorAsnef: PropTypes.bool,
    getAsnefValidation: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setPaymentDay: PropTypes.func.isRequired,
    setInitApiFlag: PropTypes.func,
    toggleINEAgreeCheckbox: PropTypes.func,
    onAgreeReset: PropTypes.func,
    officePrintReset: PropTypes.func,
    resetMailSent: PropTypes.func
};

module.exports = ContractEasyLoanStepTwo;
